import { Outlet, useOutletContext, useParams } from 'react-router-dom'

import { Box, Spinner } from '@factorialco/deprecated-design-system'
import { EmployeeMyTrainingsIndexPageDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { CommonRouteContext } from 'modules/employees/lib/types'
import { useSessionFiles } from 'modules/trainings/hooks/SessionFiles/useSessionFiles'
import { useTrainingFiles } from 'modules/trainings/hooks/TrainingFiles/useTrainingFiles'
import { useTrainingMemberships } from 'modules/trainings/hooks/TrainingMemberships/useTrainingMemberships'

const EmployeeTrainingDetail = () => {
  const { trainingId, id } = useParams()
  const { employeeAccessId } = useOutletContext<CommonRouteContext>()
  //TODO GraphQL revamp: Why are we checking this here?
  const { loading, data: employeeMyTrainingsData } = useQuery(
    EmployeeMyTrainingsIndexPageDocument,
    {
      variables: { ids: [String(trainingId)] },
    }
  )
  const trainings = employeeMyTrainingsData?.trainings.trainingsConnection.nodes
  const { trainingFiles } = useTrainingFiles({ trainingId: String(trainingId), visibility: true })
  const { sessionFiles } = useSessionFiles({ trainingId: String(trainingId), visibility: true })
  const { trainingMemberships } = useTrainingMemberships({
    trainingId: String(trainingId),
    employeeId: String(id),
  })

  if (loading || !trainingFiles || !trainingMemberships || !sessionFiles) {
    return (
      <Box width="full" alignItems="center" height="full" justifyContent="center">
        <Spinner />
      </Box>
    )
  }

  const training = trainings?.find((t) => t.id === String(trainingId))

  if (!training) return null

  return (
    <>
      <Outlet
        context={{
          employeeId: id,
          employeeAccessId,
          trainings,
          trainingFiles,
          sessionFiles,
          trainingMemberships,
        }}
      />
    </>
  )
}

export default EmployeeTrainingDetail
